export const GO='ALARM/FAILURELIST/GO';